import React from 'react';
import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleChange = (value: string | number) => {
    i18n.changeLanguage(value as string);
  };

  return (
    <Segmented
      value={i18n.language}
      onChange={handleChange}
      options={[
        {
          label: '中文',
          value: 'zh-CN',
          title: '切换到中文',
        },
        {
          label: 'English',
          value: 'en-US',
          title: 'Switch to English',
        },
      ]}
      aria-label="语言切换 / Language Switch"
      size="small"
      style={{ marginLeft: '16px' }}
    />
  );
};

export default LanguageSwitcher;
